(()=>{
  'use strict';
  const studio=handle=>'/pages/customize-anything'+(handle?'?product='+encodeURIComponent(handle):'')+'#gs2-workspace';
  document.querySelectorAll('.card-wrapper').forEach(card=>{
    const productLink=card.querySelector('a[href*="/products/"]');
    if(!productLink||card.querySelector('.gv25-customize-link'))return;
    const handle=productLink.getAttribute('href').split('/products/')[1]?.split(/[?#/]/)[0];
    if(!handle)return;
    const link=document.createElement('a');
    link.className='gv25-customize-link';
    link.href=studio(handle);
    link.textContent='Customize with your logo →';
    card.append(link);
  });
  const product=document.querySelector('.product__info-container');
  if(product&&!product.querySelector('.gv25-product-studio')){
    const handle=location.pathname.split('/products/')[1]?.split('/')[0];
    if(handle){
      const box=document.createElement('div');
      box.className='gv25-product-studio';
      const image=document.querySelector('.product__media img');
      if(image){const preview=document.createElement('img');preview.src=image.currentSrc||image.src;preview.alt='';preview.width=preview.height=74;box.append(preview)}
      const content=document.createElement('div');
      content.innerHTML='<strong>See it with your brand</strong><p>Upload a logo, add text and try a smart design direction before requesting the final production proof.</p>';
      const link=document.createElement('a');
      link.href=studio(handle);link.className='gv25-customize-link';link.textContent='Customize this product →';
      content.append(link);box.append(content);product.append(box);
    }
  }
  if(!document.querySelector('.gv25-floating-customize')){
    const floating=document.createElement('a');
    floating.className='gv25-floating-customize';floating.href=studio('');floating.textContent='✦ Customize';
    floating.setAttribute('aria-label','Open Gifty Design Studio');document.body.append(floating);
  }
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('gv25-inview');observer.unobserve(entry.target)}}),{threshold:.08});
    document.querySelectorAll('.gv25-card,.gv25-strip,.gv25-lane,.gvi article').forEach(node=>observer.observe(node));
  }
})();

